import { useContext } from "react";
import {
  GoogleMapInstanceProviderContext,
  GoogleMapInstanceContext,
} from "./GoogleMapInstanceProvider";

const useGoogleMapInstanceContext = (): GoogleMapInstanceProviderContext =>
  useContext(GoogleMapInstanceContext);

export { useGoogleMapInstanceContext };
